export default __webpack_public_path__ + "static/media/Tunic of the Doomsayer.81fd3ce5.jpg";